import "./Level6.scss";

export default function Level6() {
  return (
    <div className="level6__container">
      <div className="level6__puzzle">
        <div className="level6__file">
          <p className="level6__letter">A</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">B</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">C</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">D</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">E</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">F</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">G</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">H</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">I</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">J</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">K</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">L</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">M</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">N</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">O</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">P</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">Q</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">R</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">S</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">T</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">U</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">V</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">W</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">X</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">Y</p>
        </div>
        <div className="level6__file">
          <p className="level6__letter">Z</p>
        </div>
      </div>

      <div className="level6__guess-container">
        <span className="level6__guess">
          E &nbsp; {"->"} 9 &nbsp; + &nbsp; {"<-"} &nbsp; 5 &nbsp; + &nbsp;
          {"<-"} &nbsp; 2 &nbsp; + &nbsp; {"->"} &nbsp; 6 &nbsp; + &nbsp; {"<-"}
          &nbsp; 12
        </span>
      </div>
    </div>
  );
}
